import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalConstants } from 'src/app/constant/constant';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-terms-of-service-page',
  templateUrl: 'terms-of-service.page.html',
  styleUrls: [
    'terms-of-service.page.scss'
  ]
})

export class TermsOfServicePage {
  isTermsAccepted: boolean;

  constructor(
    public router: Router,
    public authService: AuthService
  ) {
    this.isTermsAccepted = JSON.parse(localStorage.getItem(GlobalConstants.IS_TERMSACCEPTED)) ?? false;
  }

  acceptTerms() {
    this.isTermsAccepted = true;
    localStorage.setItem(GlobalConstants.IS_TERMSACCEPTED, JSON.stringify(this.isTermsAccepted));
    this.closeTerms();
  }

  closeTerms() {
    if (this.isTermsAccepted) {
      this.router.navigate(['app/home']);
    } 
    else {
      this.authService.logout();
      this.router.navigate(['auth/login'], { replaceUrl: true });
    }
  }
}